import { render } from "./AppleScrollEffect.vue?vue&type=template&id=204f788f&scoped=true"
import script from "./AppleScrollEffect.vue?vue&type=script&lang=js"
export * from "./AppleScrollEffect.vue?vue&type=script&lang=js"

import "./AppleScrollEffect.vue?vue&type=style&index=0&id=204f788f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204f788f"]])

export default __exports__